import {
  AccessTimeTwoTone as TimeIcon,
  EventTwoTone as CalendarIcon,
  PersonOutlineTwoTone as UserIcon,
} from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { capitalize } from 'lodash'

import { TAResponseProps } from 'types/TextAnalysis'

const IconText = ({
  icon: Icon,
  text,
}: {
  icon: React.ElementType
  text: string
}) => (
  <Box display="flex" alignItems="center" gap={0.5}>
    <Icon sx={{ fontSize: '0.875rem', color: 'grey.500' }} />
    <Typography variant="caption" color="text.secondary" fontWeight={500}>
      {text}
    </Typography>
  </Box>
)

export const cardUser = ({ attributes }: TAResponseProps) => {
  const { user } = attributes.associations
  if (!user) return null

  return <IconText icon={UserIcon} text={capitalize(user.name)} />
}

export const cardMeta = ({ attributes }: TAResponseProps) => {
  const { created_at } = attributes.metadata
  if (!created_at) return null

  const dateUTC = parseISO(created_at)
  const date = format(dateUTC, 'd MMM yyyy')
  const time = format(dateUTC, 'h:mm a')

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <IconText icon={CalendarIcon} text={date} />
      <IconText icon={TimeIcon} text={time} />
    </Box>
  )
}

export const cardUserAndMeta = (props: TAResponseProps) => {
  const user = cardUser(props)
  const meta = cardMeta(props)

  if (!user && !meta) return null

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {user}
      {meta}
    </Box>
  )
}
